/**
 * Where the weekly PCA authorization pace alert leads (2026-11-01): the
 * Authorizations page's Pace tab, PCA clients that need attention. A fixed
 * link, whatever the notification's data says.
 */
import { COMPLIANCE_PAGES } from './complianceDrillDown';

const TEMPLATE = 'authorization_pace_weekly';
export const PACE_ALERT_HREF = `${COMPLIANCE_PAGES.authorizations}?view=pace&status=needs_attention&code=T1019`;

/** @returns {{ href: string, label: string }|null} */
export function authorizationPaceAlertLink(notification) {
  return notification?.templateId === TEMPLATE ? { href: PACE_ALERT_HREF, label: 'Open the Pace list' } : null;
}
